module.exports = __webpack_public_path__ + "static/media/whatsapp.dc9dd608.svg";